export async function acquireTabOwnership(uid: string, scope?: string): Promise<(() => void) | null> {
  if (!navigator.locks) return null
  return new Promise(resolve => {
    navigator.locks.request(`blinds-host-${uid}${scope ? `:${scope}` : ''}`, {ifAvailable: true}, async lock => {
      if (!lock) { resolve(null); return }
      await new Promise<void>(release => resolve(release))
    }).catch(() => resolve(null))
  })
}
